import { IFeature } from 'types'
import { LayoutContainer } from './components/LayoutContainer/LayoutContainer'
import { FEATURE_NAME } from './Layout.model'

export const LayoutFeature: IFeature = {
  title: FEATURE_NAME,

  provider: LayoutContainer,
}
